import { ProductService } from './../../../../../services/product.service';
import {Component, OnInit} from '@angular/core';
import Swal from "sweetalert2";
import { BsModalService } from 'ngx-bootstrap/modal';
import {FormBuilder, FormControl, Validators} from "@angular/forms";
import {Router} from "@angular/router";
import * as XLSX from "xlsx";
import { environment } from '../../../../../environments/environment';
import { EncryptionService } from '../../../../../services/EncryptionService';
import { SharedFonctionsService } from '../../../../../services/shared-fonctions.service';
import { IProduct, Product } from '../../../../../models/product.model';
@Component({
  selector: 'app-employe-offer',
  templateUrl: './employe-offer.component.html',
  styleUrls: ['./employe-offer.component.scss']
})
export class EmployeOfferComponent implements OnInit {

  url_photo:any;
  products: IProduct[] =[];
  productsTmp: IProduct[] =[];
  filtred:IProduct[]=[];
  filter = false;
  allProduct:IProduct[]=[];
  pageNumber: number = 1;
  pageSize: number = 10;
  totalItems :any;
  isFiltreDate: boolean;
  p = 1;
  search: any;

  // @ts-ignore
  public modalRef: BsModalRef;

  sharedIdShop : any;
  sharedINameShop : String;
  constructor(private router:Router,private productService: ProductService,private fb: FormBuilder,
              private modalService: BsModalService,private encryptionService: EncryptionService,
              private sharedSevice: SharedFonctionsService) { }

  ngOnInit(): void {
    this.url_photo=environment.url_photo;
    this.loadProductEmployeJob();
  }

  dateForm = this.fb.group({
    beginDate: ['', Validators.required],
    endDate: ['', Validators.required]
  })

  areDatesEmpty(): boolean {
    const beginDate = this.dateForm.get('beginDate').value;
    const endDate = this.dateForm.get('endDate').value;
    return !beginDate && !endDate;
  }


  loadProductEmployeJob() {
    this.productService.getProductEmployeJob(this.pageNumber-1, this.pageSize).subscribe(data=>{
      this.totalItems = data.totalElements;
      // this.product = listeProductRemoveRedondance;
      this.products = data.content;
      // this.productTmp = listeProductRemoveRedondance;
      this.productsTmp = data.content;
      //console.log("");
      //console.log(this.products);
      this.isFiltreDate = false;
    })
  }


  raiseTableSize(event: any) {
    this.pageSize = event.target.value;
    //console.log(" this.pageSize ",  this.pageSize )
    this.loadProductEmployeJob();
  }

  currentSection: string = 'mesProduits';
  toggleSection(section: string) {
    this.currentSection = section;
  }

  detailsProduit(prod:IProduct) {
    // this.modalRef = this.modalService.show(DetailsProduitListComponent,
    //   {
    //     initialState:{prod},
    //     backdrop:false,
    //     ignoreBackdropClick:true
    //   });
    // this.modalRef.content.saveEvent.subscribe((resp:any)=>this.loadProduct())
  }

  searchFilter($event: KeyboardEvent) {
    this.search = this.search.toString().toLowerCase();
    this.products = this.sortProductsByDate(
      this.productsTmp.filter(
        value => value.name?.toLowerCase().includes(this.search) || value.category?.name?.toLowerCase().includes(this.search) || value.productID?.toLowerCase().includes(this.search) || value.shop?.name?.toLowerCase().includes(this.search) || value.shop?.shopID?.toLowerCase().includes(this.search)
        || value.name?.toLowerCase().includes(this.search) || value.category?.name?.toLowerCase().includes(this.search) || value.productID?.toLowerCase().includes(this.search) || value.shop?.name?.toLowerCase().includes(this.search) || value.shop?.shopID?.toLowerCase().includes(this.search)
        || value.name?.includes(this.search) || value.category?.name?.includes(this.search) || value.productID?.includes(this.search) || value.shop?.name?.includes(this.search) || value.shop?.shopID?.includes(this.search) || value?.product_type?.name?.toLowerCase().includes(this.search)
    ));
  }

  sortProductsByDate(products: Product[]): Product[] {
    return products.sort((a, b) => {
      if (a.createdAt && b.createdAt) {
        const dateA = new Date(a.createdAt);
        const dateB = new Date(b.createdAt);
        return dateB.getTime() - dateA.getTime();
      } else {
        return 0;
      }
    });
  }

  boutiquePage()
  {
    this.router.navigate(["/boutique"]).then(() => {
      // window.location.reload();
    });
  }

  deleteProduit(prod:IProduct){
    Swal.fire({
      title: 'Voulez-vous vraiment supprimer ce produit ?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonText: 'Non',
      confirmButtonText: 'Oui'
    }).then((result) => {
      if (result.isConfirmed) {
        this.productService.deleteProduct_new(prod).subscribe(
          rs=> {

            // console.log("Response de la suppression")
            // console.log(rs)
            Swal.fire({
              position: 'top-end',
              icon: 'success',
              title: 'Votre produit est supprimé de la liste avec succès.',
              showConfirmButton: false,
              timer: 1500
            });
            this.loadProductEmployeJob();
            this.reloadComponent();
          }, error => {
            // console.log(error);
            Swal.fire({
              position: 'top-end',
              icon: 'error',
              title: error.error.errorMessage,
              showConfirmButton: false,
              timer: 1500
            })
          }
        )
      }
    })

  }

  reloadComponent() {
    let currentUrl = this.router.url;
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    this.router.onSameUrlNavigation = 'reload';
    this.router.navigate([currentUrl]);
  }

  ascendingOrderByProductName: boolean = true;
  sortByProductName(){
    this.products.sort((a, b) => {
      const nameA = a.name.toLowerCase();
      const nameB = b.name.toLowerCase();

      if(this.ascendingOrderByProductName){
        return nameA.localeCompare(nameB);
      }else {
        return nameB.localeCompare(nameA);
      }
    })
    this.ascendingOrderByProductName = !this.ascendingOrderByProductName;
  }

  ascendingOrderRef: boolean = true;
  sortByProductReference() {
    this.products.sort((a, b) => {
      const nameA = a.productID;
      const nameB = b.productID;

      if(this.ascendingOrderRef){
        return nameA.localeCompare(nameB);
      }else {
        return nameB.localeCompare(nameA);
      }
    })
    this.ascendingOrderRef = !this.ascendingOrderRef;
  }

  ascendingOrderByCreatedDate: boolean = true;
  sortByCreatedDate() {
    this.products.sort((a, b) => {
      const dateA = new Date(a.createdAt);
      const dateB = new Date(b.createdAt);
      if(this.ascendingOrderByCreatedDate){
        return dateA.getTime() - dateB.getTime();
      }else{
        return dateB.getTime() - dateA.getTime();
      }
    })
    this.ascendingOrderByCreatedDate = !this.ascendingOrderByCreatedDate;
  }

  ascendingProfilName: boolean = true;
  sortByProfilName() {
    this.products.sort((a, b) => {
      const nameA = this.getProfilName(a);
      const nameB = this.getProfilName(b);
      if(this.ascendingProfilName){
        return nameA.localeCompare(nameB);
      }else{
        return nameB.localeCompare(nameA);
      }
    })
    this.ascendingProfilName = !this.ascendingProfilName;
  }

  ascendingOrderByTypeContrat: boolean = true;
  sortByTypeContrat(){
    this.products.sort((a, b) => {
      const nameA = this.getTypeContrat(a);
      const nameB = this.getTypeContrat(b);

      if(this.ascendingOrderByTypeContrat){
        return nameA.localeCompare(nameB);
      }else {
        return nameB.localeCompare(nameA);
      }
    })
    this.ascendingOrderByTypeContrat = !this.ascendingOrderByTypeContrat;
  }

  ascendingOrderByCountryName: boolean = true;
  sortByCountryName(){
    this.products.sort((a, b) => {
      const nameA = this.getPays(a);
      const nameB = this.getPays(b);

      if(this.ascendingOrderByCountryName){
        return nameA.localeCompare(nameB);
      }else {
        return nameB.localeCompare(nameA);
      }
    })
    this.ascendingOrderByCountryName = !this.ascendingOrderByCountryName;
  }

  ascendingOrderByCityName: boolean = true;
  sortByCityName(){
    this.products.sort((a, b) => {
      const nameA = this.getVille(a);
      const nameB = this.getVille(b);

      if(this.ascendingOrderByCityName){
        return nameA.localeCompare(nameB);
      }else {
        return nameB.localeCompare(nameA);
      }
    })
    this.ascendingOrderByCityName = !this.ascendingOrderByCityName;
  }

  ascendingOrderPhoneNumber: boolean = true;
  sortByPhoneNumber() {
    this.products.sort((a, b) => {
      const mobileA = this.getPhoneNumber(a);
      const mobileB = this.getPays(b);
      if(this.ascendingOrderPhoneNumber){
        return mobileA.localeCompare(mobileB);
      }else{
        return mobileB.localeCompare(mobileA);
      }
    })
    this.ascendingOrderPhoneNumber = !this.ascendingOrderPhoneNumber;
  }

  ascendingOrderByMail: boolean = true;
  sortByMail(){
    this.products.sort((a, b) => {
      const nameA = this.getEmail(a);
      const nameB = this.getEmail(b);

      if(this.ascendingOrderByMail){
        return nameA.localeCompare(nameB);
      }else {
        return nameB.localeCompare(nameA);
      }
    })
    this.ascendingOrderByMail = !this.ascendingOrderByMail;
  }

  ascendingOrderByLimitDate: boolean = true;
  sortByLimitDate(){
    this.products.sort((a, b) => {
      const nameA = this.getLimitDate(a);
      const nameB = this.getLimitDate(b);

      if(this.ascendingOrderByLimitDate){
        return nameA.localeCompare(nameB);
      }else {
        return nameB.localeCompare(nameA);
      }
    })
    this.ascendingOrderByLimitDate = !this.ascendingOrderByLimitDate;
  }


  exportPostToExelFile(filename: string) {
    const data = document.getElementById('tab-post');
    const ws: XLSX.WorkSheet =XLSX.utils.table_to_sheet(data);

    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

    /* save to file */
    XLSX.writeFile(wb, filename);
  }

  beginDateVal: any = null;
  displayErrorMessage: boolean = false;
  getBeginDate(event: any) {
    this.beginDateVal = event.target.value;
    if(this.beginDateVal != null){
      this.disableEndDate = false;
      if(this.beginDateVal > this.endDateVal){
        this.displayErrorMessage = true;
      }else {
        this.displayErrorMessage = false;
      }
    }
  }

  endDateVal: any = null;
  disableEndDate: boolean = true;
  getEndDate(event: any) {
    this.endDateVal = event.target.value;
   // console.log(this.endDateVal);
    if(this.beginDateVal > this.endDateVal){
      this.displayErrorMessage = true;
    }else{
      this.displayErrorMessage = false;
    }
  }

  refresh() {
    this.loadProductEmployeJob();
    this.dateForm.patchValue({
      beginDate: '',
      endDate: ''
    })
  }

  filterByDate() {
    const beginDate = this.dateForm.get('beginDate').value;
    const endDate = this.dateForm.get('endDate').value;

    // Vérifier si les deux champs de date sont vides
    if (!beginDate || !endDate) {
      Swal.fire({
        position: 'top-end',
        icon: 'error',
        title: 'Veuillez renseigner la date de début et la date de fin',
        showConfirmButton: false,
        timer: 3500
      });
      return;
    } else {
      const beginDateISO = new Date(beginDate).toISOString();
      const endDateISO = new Date(endDate).toISOString();
      // console.log("Date sélectionnée")
      // console.log('beginDate:', beginDateISO);
      // console.log('endDate:', endDateISO);

      this.productService.getProductEmployeJobByDate_v1(beginDateISO, endDateISO, this.pageNumber - 1, this.pageSize).subscribe(data => {
        this.products = data.content;
        this.totalItems = data.totalElements;
        this.isFiltreDate = true
      });
    }
  }


  // searchProducts($event: KeyboardEvent) {
  //   console.log("this.products", this.products)
  //   this.products = this.productsTmp.filter(value =>
  //     // value?.subProducts[0].subProductCharacteristics.filter(s=>{
  //     //   if(s?.characteristic?.name.toLowerCase().includes("type.of.contract")) {
  //     //     s?.value.toLowerCase().includes(this.search.toLowerCase().trim())
  //     //   }
  //     // }) ||
  //     value?.name.toLowerCase().includes(this.search.toLowerCase().trim()) ||
  //     value?.productID.toLowerCase().includes(this.search.toLowerCase().trim()) ||
  //     value?.category?.name?.toLowerCase().includes(this.search.toLowerCase().trim()) ||
  //     value?.shop?.city?.name.toLowerCase().includes(this.search.toLowerCase().trim()) ||
  //     value?.shop?.city?.country?.iso.toLowerCase().includes(this.search.toLowerCase().trim()) ||
  //     value?.shop?.sellerId?.firstname.toLowerCase().includes(this.search.toLowerCase().trim()) ||
  //     value?.shop?.sellerId?.lastname.toLowerCase().includes(this.search.toLowerCase().trim()) ||
  //     value?.shop?.address.toLowerCase().includes(this.search.toLowerCase().trim()) ||
  //     (Number(this.search) === Number(value?.shop?.mobile))
  //   )
  // }
   searchProducts($event: KeyboardEvent) {
    this.products = this.productsTmp.filter(value => {
      // Filtrage basé sur le nom, l'ID du produit, la catégorie, etc.
      const basicFilter =
        value?.name.toLowerCase().includes(this.search.toLowerCase().trim()) ||
        value?.productID.toLowerCase().includes(this.search.toLowerCase().trim()) ||
        value?.category?.name?.toLowerCase().includes(this.search.toLowerCase().trim()) ||
        value?.shop?.city?.name.toLowerCase().includes(this.search.toLowerCase().trim()) ||
        value?.shop?.city?.country?.iso.toLowerCase().includes(this.search.toLowerCase().trim()) ||
        value?.shop?.sellerId?.firstname.toLowerCase().includes(this.search.toLowerCase().trim()) ||
        value?.shop?.sellerId?.lastname.toLowerCase().includes(this.search.toLowerCase().trim()) ||
        value?.shop?.address.toLowerCase().includes(this.search.toLowerCase().trim()) ||
        (Number(this.search) === Number(value?.shop?.mobile));

      // Filtrage basé sur les caractéristiques des sous-produits
      const subProductFilter = value?.subProducts.some(subProduct =>
        subProduct?.subProductCharacteristics.some(sc =>
          sc?.characteristic.name.toLowerCase().includes("type.of.contract") &&
          sc?.value.toLowerCase().includes(this.search.toLowerCase().trim())
        ) ||
        subProduct?.subProductCharacteristics.some(sc =>
          sc?.characteristic.name.toLowerCase().includes("required.profile") &&
          sc?.value.toLowerCase().includes(this.search.toLowerCase().trim())
        )
        ||
        subProduct?.subProductCharacteristics.some(sc =>
          sc?.characteristic.name.toLowerCase().includes("contract.country") &&
          sc?.value.toLowerCase().includes(this.search.toLowerCase().trim())
        )
        ||
        subProduct?.subProductCharacteristics.some(sc =>
          sc?.characteristic.name.toLowerCase().includes("contract.city") &&
          sc?.value.toLowerCase().includes(this.search.toLowerCase().trim())
        )
      );
      return basicFilter || subProductFilter;
    });
}
  // Profil recherché
  getProfilName(p): string | undefined {
      const name = "required.profile";
      if (p.subProducts[0] && p.subProducts[0].subProductCharacteristics) {
          const characteristic = p.subProducts[0].subProductCharacteristics.find(item => item.characteristic.name?.trim() === name);
          return characteristic ? characteristic.value : undefined;
      }
      return undefined;
  }

  // Type du contrat
  getTypeContrat(p): string | undefined {
    let name = "type.of.contract";
    if(p.subProducts[0] && p.subProducts[0].subProductCharacteristics){
      const characteristic = p.subProducts[0].subProductCharacteristics.find(item => item.characteristic.name?.trim() === name);
      return characteristic ? characteristic.value : undefined;
    }
  }

  // Pays
  getPays(p): string | undefined {
    let name = "contract.country";
    if(p.subProducts[0] && p.subProducts[0].subProductCharacteristics){
      const characteristic = p.subProducts[0].subProductCharacteristics.find(item => item.characteristic.name?.trim() === name);
      return characteristic ? characteristic.value : undefined;
    }
  }

  // Ville
  getVille(p): string | undefined {
    let name = "contract.city";
    if(p.subProducts[0] && p.subProducts[0].subProductCharacteristics){
      const characteristic = p.subProducts[0].subProductCharacteristics.find(item => item.characteristic.name?.trim() === name);
      return characteristic ? characteristic.value : undefined;
    }
  }

  // Numéro de téléphone
  getPhoneNumber(p): string | undefined {
    let name = "phone.number";
    if(p.subProducts[0] && p.subProducts[0].subProductCharacteristics){
      const characteristic = p.subProducts[0].subProductCharacteristics.find(item => item.characteristic.name?.trim() === name);
      return characteristic ? characteristic.value : undefined;
    }
  }

  // E- mail
  getEmail(p): string | undefined {
    let name = "email.contact";
    if(p.subProducts[0] && p.subProducts[0].subProductCharacteristics){
      const characteristic = p.subProducts[0].subProductCharacteristics.find(item => item.characteristic.name?.trim() === name);
      return characteristic ? characteristic.value : undefined;
    }
  }

  // Date limite de l’offre
  getLimitDate(p): string | undefined {
    let name = "offer.deadline";
    if(p.subProducts[0] && p.subProducts[0].subProductCharacteristics){
      const characteristic = p.subProducts[0].subProductCharacteristics.find(item => item.characteristic.name?.trim() === name);
      return characteristic ? characteristic.value : undefined;
    }
  }

  // Présentation de l'entreprise
  entreprisePresentation(p): string | undefined {
    let name = "company.presentation";
    if(p.subProducts[0] && p.subProducts[0].subProductCharacteristics){
      const characteristic = p.subProducts[0].subProductCharacteristics.find(item => item.characteristic.name?.trim() === name);
      return characteristic ? characteristic.value : undefined;
    }
  }

  //Description de l'offre
  offerDescription(p): string | undefined {
    let name = "description.of.the.offer";
    if(p.subProducts[0] && p.subProducts[0].subProductCharacteristics){
      const characteristic = p.subProducts[0].subProductCharacteristics.find(item => item.characteristic.name?.trim() === name);
      return characteristic ? characteristic.value : undefined;
    }
  }



  offerDetailsDisplayed :any;
  offerDetails(offer : any){
    this.offerDetailsDisplayed = offer;
    //console.log("Détail de l'offre ....");
    //console.log(this.offerDetailsDisplayed);
  }

  pagination(){
    if(this.isFiltreDate){
      this.filterByDate()
    }
    else{
      this.loadProductEmployeJob()
    }

  }

}
